import type { ComponentProps } from 'react';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import {
  BodyText,
  Icon,
  theme,
  usePressableState,
  useResponsive,
} from '@sweetgreen/garnish';

export const AccountMenuPrimaryItem = ({
  testID,
  label,
  iconName,
  active,
  disabled,
  onPress,
}: AccountMenuPrimaryItemProps) => {
  const ref = React.useRef(null);
  const { match } = useResponsive();
  const { isInteracting } = usePressableState(ref);

  return (
    <Pressable
      testID={testID}
      ref={ref}
      onPress={onPress}
      style={styles.container}
      accessibilityRole="link"
      accessibilityLabel={label}
      accessibilityState={{ disabled }}
      disabled={disabled}
    >
      <View style={styles.iconWrapper}>
        <Icon name={iconName} />
      </View>

      <BodyText size={match([2, 3])} underline={isInteracting || active}>
        {label}
      </BodyText>
    </Pressable>
  );
};

type AccountMenuPrimaryItemProps = {
  readonly label: string;
  readonly iconName: ComponentProps<typeof Icon>['name'];
  readonly onPress: () => void;
  readonly active?: boolean;
  readonly disabled?: boolean;
  readonly testID?: string;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: theme.radius.small,
    paddingVertical: theme.spacing.small,
    marginVertical: theme.spacing.small,
  },
  iconWrapper: {
    paddingRight: theme.spacing.medium,
  },
});
